import { ENVIRONMENT } from 'src/utils/env';

export default function log(value: any) {
  if (ENVIRONMENT === 'dev') console.log(value);
}
